import apiClient from '../core/axios';

export interface ConsoleAiPreferences {
  favorites: string[];
  recents: Array<{ actionId: string; lastUsed: string }>;
}

function unwrap<T>(body: any): T {
  return (body?.data ?? body) as T;
}

export const consoleAiPreferencesService = {
  get: async (): Promise<ConsoleAiPreferences> =>
    unwrap(((await apiClient.get('/console-ai/preferences')).data)),

  addFavorite: async (actionId: string): Promise<void> =>
    unwrap(((await apiClient.post('/console-ai/preferences/favorites', { actionId })).data)),

  removeFavorite: async (actionId: string): Promise<void> =>
    unwrap(((await apiClient.delete(`/console-ai/preferences/favorites/${actionId}`)).data)),

  recordRecent: async (actionId: string): Promise<void> =>
    unwrap(((await apiClient.post('/console-ai/preferences/recents', { actionId })).data)),
};
